import { Component, OnInit, ViewChild, ElementRef, Renderer2, Pipe, Inject, SimpleChanges } from '@angular/core';
//import { Http, ResponseContentType } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { NgbModule, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import { AgGridModule, AgGridNg2 } from 'ag-grid-angular';
import { NgxSpinnerService } from 'ngx-spinner';

import { PlantMasterService } from '../../services/plantMaster.service'

import {
    NgbDateStruct, NgbCalendar,
    NgbDatepicker,
    NgbInputDatepicker,
    NgbDateAdapter,
    NgbDateParserFormatter
} from '@ng-bootstrap/ng-bootstrap';
import { NgModel } from "@angular/forms";
import { Subscription } from 'rxjs';
import * as JSZip from 'jszip';
import * as XLSX from 'xlsx';
import { NZ_AUTOCOMPLETE_VALUE_ACCESSOR } from 'ng-zorro-antd';
import { Router, RouterModule} from '@angular/router';

@Component({
    selector: 'app-inspection, ngbd-datepicker-range, ngbd-datepicker-popup, ngbd-modal-basic',
    templateUrl: './plantMaster.component.html',
    styleUrls: ['./plantMaster.component.css']
})
export class PlantMasterComponent implements OnInit {

    @ViewChild('excelGrid') excelGrid: AgGridNg2;

    //**EXCEL **/
    excelColumnDefs = [
        { headerName: "Type", field: "plantType", editable: true },
        { headerName: "Model", field: "model", editable: true },

        { headerName: "Serial number", field: "serialNo", editable: true },

        { headerName: "Manufacturer", field: "supplier", editable: true },

        { headerName: "Capacity / Volume / SWL ", field: "capacityVolumnSWL", editable: true, cellStyle: { 'white-space': 'pre' }, cellEditor: "agLargeTextCellEditor" },
        { headerName: "Vehicle plate", field: "vehiclePlate", editable: true },

        { headerName: "Owner", field: "owner", editable: true },
        { headerName: "Owner's number", field: "ownerNumber", editable: true },
        { headerName: "User Company", field: "userCompany", editable: true },

        { headerName: "Date in", field: "fromDate", editable: true, cellEditor: "datePicker" },
        { headerName: "Date out", field: "toDate", editable: true, cellEditor: "datePicker" },
        { headerName: "Area Manager", field: "areaMgr", editable: true },

        { headerName: "Coordinator", field: "permitCoordinator", editable: true },

        { headerName: "Permitnumber", field: "permitNo", editable: true },
        { headerName: "Expiry date", field: "permitExpiryDate", editable: true },
        { headerName: "Certificate number", field: "statCertNo", editable: true },
        { headerName: "Issue Date", field: "statCertIssueDate", editable: true, cellEditor: "datePicker" },
        { headerName: "Expiry date", field: "statCertExpiryDate", editable: true, cellEditor: "datePicker" },
        { headerName: "Issue date", field: "CPIIssueDate", editable: true, cellEditor: "datePicker" },
        { headerName: "Expiry date", field: "CPIExpiryDate", editable: true, cellEditor: "datePicker" },
        { headerName: "Approval (Green)", field: "NRMM_ApprovalGreen", editable: true },
        { headerName: "Exemption (Yellow)", field: "NRMM_ExemptionYellow", editable: true },
        { headerName: "Remark", field: "remark", editable: true },
        { headerName: "QPME", field: "QPMENo", editable: true }
        // { headerName: "Serial Number", field: "serialNo", editable: true },
        // { headerName: "Plant Number", field: "plantNo", editable: true },
        // { headerName: "Plant Type", field: "plantType", editable: true },
        // { headerName: "Supplier", field: "supplier", editable: true },
        // { headerName: "Model", field: "model", editable: true },
        // { headerName: "Owner", field: "owner", editable: true },
        // { headerName: "Manufacture Date", field: "manufactureDate", editable: true, cellEditor: "datePicker" },
        // //{ headerName: "Manufacture Date", field: "manufactureDate", editable: true },
        // { headerName: "NRMM Label", field: "nrmmLabel", editable: true }
    ];
    excelGridComponents = { datePicker: getDatePicker() };
    excelData: any;
    excelGridOptions = {
        rowHeight: 75
    }

    excelImportJob;

    dtOptions: DataTables.Settings = {};

    constructor(private plantMasterService: PlantMasterService,
        calendar: NgbCalendar, element: ElementRef,
        private renderer: Renderer2, private _parserFormatter: NgbDateParserFormatter,
        private modalService: NgbModal,
        private http: HttpClient,
        private router : Router,
        private spinner: NgxSpinnerService
        //  private modalService: ModalService
    ) {
    }

    ngOnInit() {

        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10
        };

        this.excelData = [];
    }

    saveExcel() {
        this.spinner.show();
        var importList = [];
        var count = this.excelGrid.api.getDisplayedRowCount();
        for (var i = 0; i < count; i++) {
            var item = this.excelGrid.api.getDisplayedRowAtIndex(i).data;
            importList.push(item);
            //console.log('row ' + i + ' is ' + rowNode.data.athlete);
        }
        console.log(importList);
        if (importList.length > 0) {
            console.log(this.excelData);
            this.plantMasterService.importJobPlant(importList, this.excelImportJob).subscribe(data => {
                //this.rowData = data.slice(0);
                this.spinner.hide();

                if(data == 'Success')
                {
                    alert("Records uploaded");
                    this.router.navigate(['./jobPlant']);
                } 
                else
                {
                    alert("Fail to upload");
                }
                
                console.log('data:' + data)
            });;

            
        }
    }

    importExcel($event, item) {
        //add this if going to get global variable in local this function
        var self = this;
        readExcel($event, function (returnData) {
            self.excelData = returnData;
        });

        function readExcel($data, onProcessedCallback) {
            var filesToUpload = $data.target.files;
            var file = filesToUpload[0];
            var canvas = document.createElement('canvas');
            var excelDataList = [];

            //var img = document.createElement("img");

            var reader = new FileReader();
            reader.onload = function (e) {
                const wb: XLSX.WorkBook = XLSX.read(this.result, { type: 'binary' });
                const wsname: string = wb.SheetNames[0];
                const ws: XLSX.WorkSheet = wb.Sheets[wsname];

                /* save data */
                //var data = <any>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
                //console.log(data);
                //var htmlstr = XLSX.write(wb, { sheet: wsname, type: 'binary', bookType: 'html' });
                //$('#excelWrapper')[0].innerHTML += htmlstr;

                var csvData = <any>(XLSX.utils.sheet_to_csv(ws));
                //console.log(csvData);

                var itemList = csvData.split(',');
                //console.log(itemList);
                for (var i = 0; i < itemList.length; i++) {
                    if (itemList[i][0] != '\"' && itemList[i].indexOf('\n') >= 0 && itemList[i].length > 1) {
                        //console.log(itemList[i]);
                        var thisItemList = itemList[i].split('\n');
                        if (thisItemList.length == 2) {
                            itemList.splice(i, 1)
                            itemList.splice(i, 0, thisItemList[1]);
                            //console.log(itemList);
                            itemList.splice(i, 0, thisItemList[0]);
                            //console.log(itemList);
                            i++;
                        }
                        // console.log(itemList[i]);
                        // console.log(thisItemList);
                        // //var secondItem = '';
                        // //itemList.splice(1,i,"15S");
                        // console.log(itemList[i]);
                        // itemList[i].split('\n');
                    }
                }
                // console.log(itemList);
                // console.log(itemList.length);
                var jobNoIndex = itemList.indexOf('Job') + 1;

                console.log(jobNoIndex);
                self.excelImportJob = Number(itemList[jobNoIndex]);
                console.log(self.excelImportJob);

                var lastHeaderItemIndex = itemList.indexOf('QPME');
                console.log(lastHeaderItemIndex);
                var column = Number(lastHeaderItemIndex) + 1;
                for (var i = column; i < itemList.length; i++) {
                    console.log(itemList[i + 4])

                    // if (itemList[i + 4].length > 0) {
                        var newExcelData = {
                            jobNo: self.excelImportJob,
                            // serialNo: arrayItem[column + 0],
                            // plantNo: arrayItem[column + 1],
                            // plantType: arrayItem[column + 2],
                            // supplier: arrayItem[column + 3],
                            // model: arrayItem[column + 4],
                            // owner: arrayItem[column + 5],
                            // manufactureDate: arrayItem[column + 6],
                            // nrmmLabel: arrayItem[column + 7]
                            plantType: itemList[i + 0],
                            model: itemList[i + 1],
                            serialNo: itemList[i + 2],
                            supplier: itemList[i + 3],
                            //capcityVolumnSWL: itemList[i + 4],
                            //capcityVolumnSWL: itemList[i + 4].replace(new RegExp('\n', 'g'), '<br />'),
                            capacityVolumnSWL: itemList[i + 4].replace(new RegExp('"', 'g'), ''),
                            vehiclePlate: itemList[i + 5],
                            owner: itemList[i + 6],
                            plantNoOwner: itemList[i + 7],
                            userCompany: itemList[i + 8],
                            fromDate: itemList[i + 9],
                            toDate: itemList[i + 10],
                            areaMgr: itemList[i + 11],
                            permitCoordinator: itemList[i + 12],
                            permitNo: itemList[i + 13],
                            permitExpiryDate: itemList[i + 14],
                            statCertNo: itemList[i + 15],
                            statCertIssueDate: itemList[i + 16],
                            statCertExpiryDate: itemList[i + 17],
                            CPIIssueDate: itemList[i + 18],
                            CPIExpiryDate: itemList[i + 19],
                            NRMM_ApprovalGreen: itemList[i + 20],
                            NRMM_ExemptionYellow: itemList[i + 21],
                            remark: itemList[i + 22],
                            QPMENo: itemList[i + 23]
                        };

                        console.log(newExcelData);

                        excelDataList.push(newExcelData)
                    // }
                    i += 23;
                }
                console.log(excelDataList);
                onProcessedCallback(excelDataList);
            };
            reader.readAsBinaryString(file);
            return excelDataList;
        };
    }
}
function getDatePicker() {
    function Datepicker() { }
    // var a = document.createElement('a');
    // document.body.appendChild(a);
    // a.setAttribute('style', 'display: none');
    // a.href = url;
    // a.download = photo.fileName;
    // a.click();
    // window.URL.revokeObjectURL(url);
    // a.remove(); 
    Datepicker.prototype.init = function (params) {
        // console.log('dp init')
        // console.log(this);
        // console.log('dp init ' + this.eInput);
        this.eInput = document.createElement("input");
        this.eInput.value = params.value;
        // console.log('dp ' + (<any>$(this.eInput)));
        (<any>$(this.eInput)).datepicker({
            format: "yyyy-mm-dd"
        });
        //console.log('dp init ' + this.eInput.value);
    };
    Datepicker.prototype.getGui = function () {
        // console.log('dp getGui')
        // console.log('dp getGui ' + this.eInput.value);
        return this.eInput;
    };
    Datepicker.prototype.afterGuiAttached = function () {
        // console.log('dp afterGuiAttached')
        // console.log('dp afterGuiAttached ' + this.eInput.value);
        this.eInput.focus();
        this.eInput.select();
        // console.log(this);
        // console.log(this.eInput);
        // console.log(this.eInput.value);
        this.eInput.remove();
    };
    Datepicker.prototype.getValue = function () {
        // console.log('dp getValue')
        // console.log('dp getValue ' + this.eInput.value);
        return this.eInput.value;
    };
    Datepicker.prototype.destroy = function () {
        // console.log('dp destroy')
        // console.log('dp destroy ' + this.eInput.value);
        // console.log(this);
        // console.log(this.eInput);
        this.eInput.remove();
        //(<any>$(this.eInput)).remove();
    };
    Datepicker.prototype.isPopup = function () {
        // console.log('dp isPopup')
        // console.log('dp isPopup ' + this.eInput.value);
        return false;
    };
    return Datepicker;
}
